type TimelineStepItem = {
  readonly sys?: {
    readonly id?: string | null;
  } | null;
  readonly restrictedRichTextBlock?: {
    readonly body?: {
      readonly json?: unknown;
      readonly links?: unknown;
    } | null;
  } | null;
} | null;

export interface TimelineStepContent {
  readonly key: string;
  readonly json: unknown;
  readonly links: unknown;
}

export const mapTimelineStepsToContent = (
  steps: ReadonlyArray<TimelineStepItem> | null | undefined,
): TimelineStepContent[] => {
  if (!steps?.length) {
    return [];
  }

  return steps.flatMap((item, index) => {
    const body = item?.restrictedRichTextBlock?.body;
    if (!body?.json) {
      return [];
    }

    return [
      {
        key: item?.sys?.id ?? `timeline-step-${index}`,
        json: body.json,
        links: body.links ?? null,
      },
    ];
  });
};
